<script setup>
import { rules } from "@/services/CommonService"
import { useAuthStore } from "@/stores/authStore"
import { useAppStore } from "@/stores/appStore"
import { login } from "@/services/ApiUrlService"
import { router } from "@/plugins/1.router"
import { useRoute } from "vue-router"
import { useCustomSwal } from "@/composables/usePopup"
import Swal from "sweetalert2"
import {
  listCard,
  listCardBottom,
  contentTabsUniversities,
  contentTabsRh,
  contentTabsStudent,
  contentTabsAbout,
  contentTabsBachelors,
  contentTabsMaster,
} from "@/utils/content"
import ListCard from "@/views/login/ListCard.vue"
import ForgotPassword from "@/views/ForgotPassword.vue"
import FooterBlank from "@/layouts/components/FooterBlank.vue"
const { showCustomSwal } = useCustomSwal()
import { enums as LEVEL } from "@/config/enums/ProgramLevel"
const { required } = rules
definePage({
  meta: {
    layout: "blank",
    unauthenticatedOnly: true,
  },
})

const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR
const CAMPAIGN = import.meta.env.VITE_CAMPAIGN
const loading = ref(false)
const successNoti = ref(false)
const errorNoti = ref(false)
const messageNoti = ref("")
const isConfirmDialogVisible = ref(false)
const isDialogVisibleMoreInfo = ref(false)
const isPasswordVisible = ref(false)
const route = useRoute()
const typePopup = ref(null)

const errors = ref({
  username: null,
  password: null,
})

const refVForm = ref()
const authStore = useAuthStore()
const credentials = ref({
  username: "",
  password: "",
})

const programMajor = computed(() => {
  return useAppStore().getList("getProgramMajor")
})
const majorProgramCondition = computed(() => {
  const survey = typePopup.value
  if (!programMajor.value) return []
  const specPrixList = [1, 14, 38, 39, 40]
  if (survey === "MM") {
    return programMajor.value
      .filter((item) => [LEVEL.MM, LEVEL.MBA].includes(item.programLevel?.id))
      .filter((item) => !specPrixList.includes(item.id))
  } else if (survey === "MB") {
    return programMajor.value
      .filter((item) => !specPrixList.includes(item.id))
      .filter((item) => [LEVEL.MB].includes(item.programLevel?.id))
  }
  return []
})
function openPopupType(type) {
  if (type === "student") {
    Swal.fire({
      title: $gettext("Connexion Etudiants"),
      html: `
        <p style="font-size: 14px; font-weight: normal; font-style: normal;" class="text-black text-justify">
          ${$gettext(
            "Vous ne pouvez pas vous inscrire ici si vous êtes un étudiant."
          )}
        </p>
        <p style="font-size: 14px; font-weight: normal; font-style: normal;" class="text-black text-start">
          ${$gettext(
            "Vos identifiants vous ont déjà été envoyés par e-mail depuis l'adresse : Eduniversal Evaluation Agency."
          )} <a class="pointer text-sky" href="mailto:classements.france@eduniversal-group.com"><u>(classements.france@eduniversal-group.com)</u></a>
          
        </p>
        <p style="font-size: 14px; font-weight: normal; font-style: normal;" class="text-black text-justify">
          ${$gettext(
            "Si vous ne les trouvez pas, vérifiez vos courriers indésirables."
          )}
        </p>
      `,
      showCancelButton: false,
      showConfirmButton: false,
      showCloseButton: true,
      position: "top",
    })
  } else if (type === "recruiter") {
    Swal.fire({
      title: $gettext("Connexion Entreprises / Recruteurs"),
      html: `
        <p style="font-size: 14px; font-weight: normal; font-style: normal;" class="text-black text-justify">
          ${$gettext(
            "Vous ne pouvez pas vous inscrire ici si vous êtes une entreprise ou un recruteur."
          )}
        </p>
        <p style="font-size: 14px; font-weight: normal; font-style: normal;" class="text-black text-start">
          ${$gettext(
            "Vos identifiants vous ont déjà été envoyés par e-mail depuis l'adresse : Eduniversal Evaluation Agency"
          )} <a class="pointer text-sky" href="mailto:classements.france@eduniversal-group.com"><u>(classements.france@eduniversal-group.com)</u></a>
        </p>
        <p style="font-size: 14px; font-weight: normal; font-style: normal;" class="text-black text-justify">
          ${$gettext(
            "Si vous ne les trouvez pas, vérifiez vos courriers indésirables."
          )}
        </p>
      `,
      showCancelButton: false,
      showConfirmButton: false,
      showCloseButton: true,
      position: "top",
    })
  }
}
const loginUser = async () => {
  loading.value = true
  try {
    const response = await $api(login, {
      method: "POST",
      body: {
        username: credentials.value.username,
        password: credentials.value.password,
      },
      loading: true,
      noPushMessage: true,
    })
    console.log("response", response)
    authStore.login(response, route)
  } catch (error) {
    await showCustomSwal({
      html: `<h4 class="text-error mb-0">${$gettext(
        "Les informations de connexion sont incorrectes. Veuillez vérifier votre identifiant et votre mot de passe, puis réessayer"
      )}</h4>`,
      showConfirmButton: false,
      showCloseButton: true,
    })
  } finally {
    loading.value = false
  }
}

const onSubmit = () => {
  refVForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid) loginUser()
  })
}

function redirectPage(url) {
  router.push(url)
}

// const isRefresh = ref(false)
// const onChangeLang = () => {
//   isRefresh.value = true
//   nextTick(() => {
//     isRefresh.value = false
//   })
// }

watch(
  () => typePopup.value,
  (newval) => {
    typePopup.value = newval
  },
  { immediate: true }
)
const START_DATE = import.meta.env.VITE_START_DATE
const END_DATE = import.meta.env.VITE_END_DATE
</script>

<template>
  <div class="login-custom">
    <div class="login-custom__banner">
      <header class="login-custom__header">
        <RouterLink to="/" class="app-logo app-title-wrapper">
          <img
            src="@/assets/images/Logo_EEA_Ocre.png"
            alt="Logo"
            width="228"
            height="125"
          />
        </RouterLink>
        <h1 class="login-custom__header-title text-bree">
          {{ $gettext("Enquêtes France") }} {{ CURRENT_YEAR }}
        </h1>
        <!-- <div class="text-center" style="width: 148px">
          <BtnLang @onChange="onChangeLang" />
        </div> -->
      </header>
      <div class="login-custom__sub-header">
        <div class="login-custom__sub-header__container">
          <!-- <p v-if="CAMPAIGN === true">
            {{
              $gettext(
                "L’enquête Eduniversal 2025 en vue de l’élaboration des Classements Eduniversal 2026 est ouverte"
              )
            }}
            <br />
            <u>du {{ START_DATE }} au {{ END_DATE }}</u>
          </p> -->
          <div class="text-center">
            <p>
              {{
                $gettext(
                  "L'enquête Eduniversal "
                )
              }}
              {{ CURRENT_YEAR }} {{ $gettext("en vue de l'élaboration des Classements") }} {{ +CURRENT_YEAR + 1 }} {{ $gettext("est désormais close.") }}
            </p>
            <p>
              {{
                $gettext(
                  "Les résultats seront rendus publics"
                )
              }}
              <span class="text-second-primary">{{ $gettext("en janvier et mars") }} {{ +CURRENT_YEAR + 1 }}</span>       
              <!-- <a
                class="text-blue"
                target="_blank"
                href="https://www.meilleurs-masters.com/"
              >
                <u>www.meilleurs-masters.com</u>
              </a>
              {{ $gettext("en mars 2026.") }} -->
            </p>
            <!-- <p>
              {{
                $gettext(
                  "Le Classement 2026 des meilleurs Licences, Bachelors et Grandes Écoles sera quant à lui rendu public sur"
                )
              }}
              <a
                class="text-second-primary"
                href="https://www.meilleurs-masters.com/"
                target="_blank"
              >
                {{
                  $gettext(
                    "Classement des meilleurs Bachelors et Licences Eduniversal"
                  )
                }}
                {{ CURRENT_YEAR }}
              </a>
              {{ $gettext("en janvier") }} {{ +CURRENT_YEAR + 1 }}
            </p> -->
          </div>
        </div>
      </div>
      <div class="login-custom__hero">
        <div class="login-custom__hero-left">
          <h2 class="text-bree">{{ CURRENT_YEAR }}</h2>
          <p class="text-bree">
            {{
              $gettext(
                "Répondez à nos enquêtes pour l'évaluation de vos programmes, en vue des prochains classements"
              )
            }}
            !
          </p>
        </div>

        <div class="login-custom__hero-right">
          <VForm @submit.prevent="onSubmit" ref="refVForm" :disabled="true">
            <h2>{{ $gettext("Connexion Universités et Ecoles") }}</h2>
            <div class="d-flex flex-column gap-3">
              <div class="login-custom__hero-right-input">
                <AppTextField
                  style="border-radius: 25px"
                  v-model="credentials.username"
                  autofocus
                  type="username"
                  color="opacity"
                  prepend-inner-icon="tabler-user"
                  :placeholder="$gettext('Identifiant / Adresse mail')"
                  :rules="[
                    requiredValidator,
                    emailValidator(
                      credentials.username,
                      $gettext(
                        'Le format de l\'email saisi est invalide. Veuillez entrer une adresse email valide'
                      )
                    ),
                  ]"
                  :error-messages="errors.username"
                />
              </div>
              <div class="login-custom__hero-right-input">
                <AppTextField
                  v-model="credentials.password"
                  :placeholder="$gettext('Mot de passe')"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :rules="[requiredValidator]"
                  :error-messages="errors.password"
                >
                  <template #prepend-inner>
                    <VIcon icon="tabler-lock" color="opacity" />
                  </template>
                  <template #append-inner>
                    <VIcon
                      class="pointer"
                      @click="isPasswordVisible = !isPasswordVisible"
                      :icon="
                        isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'
                      "
                      size="20"
                      color="opacity"
                    />
                  </template>
                </AppTextField>
              </div>
            </div>

            <div
              class="mt-4 d-flex align-center gap-3 w-100"
              style="justify-content: space-between"
            >
              <SubmitBtn
                class="mt-3 button-submit w-50"
                type="submit"
                :loading="loading"
                :disabled="true"
              >
                {{ $gettext("Connexion") }}
              </SubmitBtn>
              <!-- <ForgotPassword /> -->
            </div>

            <h2 class="mb-0 my-5 text-nunito">
              {{ $gettext("Pas encore inscrit ?") }}
            </h2>
            <div
              class="redirect-register pointer"
              @click="redirectPage('/inscription')"
            >
              {{ $gettext("Créer votre compte") }}
            </div>

            <div class="button-bottom-login text-nunito">
              <button type="button" @click="openPopupType('student')">
                {{ $gettext("Connexion Etudiants") }}
              </button>
              <button type="button" @click="openPopupType('recruiter')">
                <p class="mb-0">
                  {{ $gettext("Connexion Entreprises / Recruteurs") }}
                </p>
              </button>
            </div>
          </VForm>
        </div>
      </div>
    </div>

    <div class="login-custom__list-container">
      <ListCard
        :data="listCard"
        v-model="isDialogVisibleMoreInfo"
        v-model:typePopup="typePopup"
      />
    </div>
    <div class="login-custom__bottom">
      <div class="login-custom__bottom-container">
        <ListCard
          :data="listCardBottom"
          v-model="isDialogVisibleMoreInfo"
          v-model:typePopup="typePopup"
        />
      </div>
    </div>
    <FooterBlank />
  </div>
  <Notification
    v-model:isDialogVisible="isConfirmDialogVisible"
    :success="successNoti"
    :error="errorNoti"
    :message="messageNoti"
    :isShowLoading="true"
  />
  <MoreInfo
    v-model:isDialogVisibleMoreInfo="isDialogVisibleMoreInfo"
    :data="
      typePopup === 'school'
        ? contentTabsUniversities
        : typePopup === 'RH'
        ? contentTabsRh
        : typePopup === 'student'
        ? contentTabsStudent
        : typePopup === 'about'
        ? contentTabsAbout
        : typePopup === 'MB'
        ? contentTabsBachelors
        : typePopup === 'MM'
        ? contentTabsMaster
        : {}
    "
    :dataSpec="majorProgramCondition"
  />
</template>

<style lang="scss" scoped>
@use "@core/scss/template/pages/page-auth.scss";
@use "@/assets/styles/pages/login.scss";

.button-submit {
  min-width: unset;
  margin: unset;
  border-radius: 25px;
  margin-top: 0 !important;
}
.button-bottom {
  justify-content: unset;
  gap: 10px;
}

#swal2-title {
  color: #000 !important;
  @media (max-width: 768px) {
    font-size: 16px;
  }
}
.student-popup-login {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
}
</style>
